import { Save } from "@mui/icons-material";
import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";

export default function SaveButton({ rowID, setRowModesModel }) {
  const handleClick = () => {
    setRowModesModel((rowModesModel) => {
      return {
        ...rowModesModel,
        [rowID]: { mode: GridRowModes.View },
      };
    });
  };

  return (
    <GridActionsCellItem icon={<Save />} label={"Save"} onClick={handleClick} />
  );
}
